import { render, staticRenderFns } from "./createcollector.vue?vue&type=template&id=0dfa34de&"
import script from "./createcollector.vue?vue&type=script&lang=ts&"
export * from "./createcollector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "createcollector.vue"
export default component.exports